import {ModuleComponent} from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";

export class ModWebDocumentationList extends ModuleComponent {

    getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    ready() {
        super.ready();

        const brandItems = document.querySelectorAll(this.scope + "__filter-brand");
        const documentTypeId = this.$root.data('documentation-type');

        brandItems.forEach(item => {
            item.addEventListener("click", function () {
                brandItems.forEach(brandItem => {
                    brandItem.classList.remove("active");
                });
                const filterId = item.getAttribute('data-brand');
                GvfService.endpoint(
                    '/web/web-documentation/render-web-documentation-by-filter',
                    {webBrandId:filterId,documentTypeId:documentTypeId}
                ).then((resp) => {

                    if (resp.html) {
                        const contentDiv = document.getElementById('documentation');
                        contentDiv.innerHTML = resp.html;
                        GvfUiService.init($(resp.html));
                    }
                });
                item.classList.add("active");
            });
        });

    }
}

